import { createContext } from 'react';

import type { IndividualCalendarContextInterface } from '@pages/IndividualCalendar/context/IndividualCalendarContext.types';

type Nullable<T> = T | null;

export const IndividualCalendarContext =
  createContext<Nullable<IndividualCalendarContextInterface>>(null);
